import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// AuthGuard für authenticated-only Routes.
// Wenn keine Session → redirect zu /login mit `from`-State damit nach Login
// zurück zum gewünschten Pfad navigiert werden kann.
export function AuthGuard() {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Während Hydration: neutraler Block, kein Flash zu Login
    return <div className="min-h-screen bg-base" aria-busy="true" />;
  }

  if (!session) {
    // ⚠ Pfad UND Query merken. Nur `pathname` verlöre den Zustand, der in der Adresse
    // steckt — ein geteilter Link („schau dir meinen Entwurf an und gib ihn frei", #278)
    // landete nach dem Login auf der leeren Seite statt am Ziel. Für die Sitzung selbst
    // ist das unerheblich, für jeden verschickten Link entscheidend.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
